/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProfilePictureBody
 */
export interface UpdateProfilePictureBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfilePictureBody
     */
    assetID?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfilePictureBody
     */
    nftID?: string;
}

/**
 * Check if a given object implements the UpdateProfilePictureBody interface.
 */
export function instanceOfUpdateProfilePictureBody(value: object): value is UpdateProfilePictureBody {
    return true;
}

export function UpdateProfilePictureBodyFromJSON(json: any): UpdateProfilePictureBody {
    return UpdateProfilePictureBodyFromJSONTyped(json, false);
}

export function UpdateProfilePictureBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfilePictureBody {
    if (json == null) {
        return json;
    }
    return {
        
        'assetID': json['assetID'] == null ? undefined : json['assetID'],
        'nftID': json['nftID'] == null ? undefined : json['nftID'],
    };
}

export function UpdateProfilePictureBodyToJSON(json: any): UpdateProfilePictureBody {
    return UpdateProfilePictureBodyToJSONTyped(json, false);
}

export function UpdateProfilePictureBodyToJSONTyped(value?: UpdateProfilePictureBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetID': value['assetID'],
        'nftID': value['nftID'],
    };
}

